/**
 * Pure H OS · Phase D Wave 3 · Meetings (types + live view).
 * MongoDB collection: `pureh_meetings`.
 */
import { liveArray } from "../services/store";

export type MeetingKind = "weekly" | "monthly" | "quarterly" | "1on1" | "adhoc";
export type MeetingStatus = "scheduled" | "closed";

export type Meeting = {
  id: string;
  title: string;
  kind: MeetingKind;
  scheduledRelative: string;
  attendees: string[];
  owner: string;
  decisionsMade: number;
  actionItems: number;
  status: MeetingStatus;
  agenda?: string;
  minutes?: string;
  actionItemsList?: string[];
};

export const MEETINGS: Meeting[] = liveArray<Meeting>("meetings");
